<template>
	<div>
		<div class="">
			<H5>PROFIT & LOSS</H5>
			<!--<div class="row" v-for="(item, index) in this.finance.segment" :key="index">
				<div class="card cardptpr mb-4" >
					<FinanceTable :card_title="item.SegmentName" :segment="item.SegmentID" :plant="plant" :key="plant" />
				</div>
			</div>-->
			<FinanceTable card_title="CONSOL" :segment="1" :plant="plant" :key="plant" />
		</div>
	</div>
</template>

<script>
import Basic from '@/components/page/Basic.js'
import FinanceTable from '@/views/pages/FinanceTable.vue'

export default{
	extends: Basic,
	props:["plant"],
	components:{
		FinanceTable,
	},
    mounted(){
		this.loadSegment();
    },
    methods:{

	}
}

</script>